(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-catalog"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.catalog-search').forEach((form) => {
    const input = form.querySelector('.catalog-search__input');
    const clearButton = form.querySelector('.catalog-search__clear');

    if (!input || !clearButton) return;

    const updateClearButton = () => {
      clearButton.hidden = input.value.length === 0;
    };

    input.addEventListener('input', updateClearButton);
    clearButton.addEventListener('click', () => {
      input.value = '';
      updateClearButton();
      input.focus();
    });
    updateClearButton();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  document.querySelectorAll('.search-page__form').forEach((form) => {
    const input = form.querySelector('.search-page__input');
    const clearButton = form.querySelector('.search-page__clear');

    if (!input || !clearButton) return;

    const updateClearButton = () => {
      clearButton.hidden = input.value.length === 0;
    };

    input.addEventListener('input', updateClearButton);
    clearButton.addEventListener('click', () => {
      input.value = '';
      updateClearButton();
      input.focus();
    });
    updateClearButton();
  });

  } catch(e) { console.error(e); }
})();
})();
